module.exports = __webpack_public_path__ + "img/logo_f.b42a9395.svg";